<template>
	<div>
		<div class="card align-item-center px-1 py-0 flex-lg-row justify-content-md-between p-2">
			<ul class="nav nav-tabs align-items-center gap-x-2 mb-0 w-100" role="tabslits">
				<b-nav-item
					link-classes="px-1 justify-content-between w-100"
					class="x-tab-width"
					:to="{ name: 'posturas-sr-pendientes' }"
					:active="
						[
							'posturas-sr-pendientes',
							'posturas-sr-activas',
							'posturas-sr-por finalizar',
							'posturas-sr-finalizadas',
							'posturas-sr-anuladas',
							'padrillos-con-posturas-sr',
							'padrillos-sin-posturas-sr',
							'madrillas-con-posturas-sr',
							'madrillas-sin-posturas-sr',
						].includes($route.name)
					"
				>
					<span>Posturas</span>
				</b-nav-item>
				<b-nav-item
					link-classes="px-1 justify-content-between w-100"
					class="x-tab-width"
					:to="{ name: 'insemination-sr-pendientes' }"
					:active="'insemination-sr-pendientes' == $route.name"
				>
					<span>Inseminación</span>
					<b-badge v-if="counter > 0" pill variant="danger" class="ml-1">
						{{ counter }}
					</b-badge>
				</b-nav-item>
			</ul>
		</div>

		<div v-if="$route.name != 'posturas-insemination'" class="card p-2 container-select-year">
			<b-form-group class="mb-0" style="min-width: 12rem" v-if="$route.name != 'posturas-insemination'">
				<v-select
					class="mb-0 w-100"
					v-model="season"
					:options="seasons"
					label="season"
					:reduce="(option) => option.id"
					@input="setYearMain($event)"
					:clearable="false"
					transition=""
					placeholder="Seleccione un año"
				/>
			</b-form-group>
			<div class="d-flex gap-x-2">
				<b-button variant="outline-primary" class="position-relative" @click="showCheck = true">
					Check Madrillas
					<b-badge
						v-if="G_COUNTER_CHECK_MADRILLAS.total > 0"
						variant="danger"
						style="top: -8px; right: -8px"
						class="position-absolute"
					>
						{{ G_COUNTER_CHECK_MADRILLAS.total }}
					</b-badge>
				</b-button>
				<!-- <b-button
					variant="outline-primary"
					class="position-relative"
					@click="posturasActiveModal = !posturasActiveModal"
				>
					Padrillos dispuestos
				</b-button> -->
			</div>
		</div>

		<div
			class="card align-item-center px-1 py-0 flex-lg-row justify-content-md-between"
			v-if="$route.name != 'posturas-insemination'"
		>
			<ul class="nav nav-tabs align-items-center gap-x-2 mb-0 w-100" role="tabslits">
				<b-nav-item
					v-for="(tab, index) in tabArray"
					link-classes="px-1 justify-content-between w-100"
					class="x-tab-width"
					:to="{ name: tab.path }"
					:key="`${index}-posturas-main-index`"
					:active="tab.id == status"
				>
					<span>{{ tab.name }}</span>
					<b-badge pill variant="danger" class="ml-1">
						{{ tab.counter }}
					</b-badge>
				</b-nav-item>
			</ul>
			<div class="text-center mt-1 d-md-none">
				<p class="mb-0 font-weight-bolder">VER POR:</p>
			</div>
			<ul
				class="nav nav-tabs align-items-center justify-content-between mb-1 mb-lg-0 justify-content-md-start mb-0 flex-nowrap"
				role="tabslits"
				:style="{ paddingLeft: '0rem !important', paddingRight: '0rem !important' }"
			>
				<b-nav-item link-classes="px-0" href="#" disabled class="d-none d-md-flex pm-by-item-label">
					<strong class="text-dark mr-1" style="white-space: nowrap">VER POR:</strong>
				</b-nav-item>
				<b-nav-item
					link-classes="py-2 pm-by-nav-item p-25 p-lg-2"
					:to="{ name: 'posturas-sr-por-padrillos' }"
					title=""
				>
					<div
						class="btn-specimen-posturas"
						:class="[$route.meta.category == 1 ? 'btn-specimen-posturas-active' : '']"
					>
						<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M22.9975 11.1449L22.8632 11.2869L22.9686 11.4515C24.6252 14.0378 25.2787 17.1512 24.8034 20.1947C24.3282 23.2382 22.7578 25.9967 20.3941 27.9418C18.0305 29.8868 15.0398 30.8816 11.9956 30.736C8.95134 30.5905 6.06693 29.3148 3.89553 27.1528L3.89371 27.151C-0.314751 23.0455 -0.936913 16.1696 2.33605 11.235C5.23183 6.87203 12.4914 3.26267 19.8801 8.09257L20.0526 8.20531L20.1962 8.05755L23.6418 4.51217L24.0541 4.08794H23.4625C23.1863 4.08794 22.9199 4.08939 22.6597 4.0908C22.1578 4.09353 21.679 4.09614 21.198 4.08798C20.6139 4.07749 20.1479 3.89024 19.8264 3.58913C19.5061 3.28912 19.3114 2.85949 19.2976 2.32744C19.2837 1.79197 19.4529 1.32468 19.7527 0.988539C20.0512 0.653949 20.4912 0.435433 21.0483 0.415898L21.0486 0.415884C23.6115 0.32193 26.175 0.266664 28.7393 0.250084L28.7396 0.250081C29.3334 0.245365 29.8218 0.445794 30.1632 0.781521C30.5048 1.11734 30.7154 1.60444 30.7238 2.20261V2.20266C30.7607 4.7932 30.7566 7.38409 30.7238 9.97542L30.7238 9.97576C30.7109 11.1206 29.848 11.9597 28.8627 11.9525C27.8773 11.9453 27.1093 11.1896 27.0344 10.0476C26.9983 9.48784 27.007 8.93431 27.0161 8.35112C27.0203 8.08037 27.0246 7.80324 27.0246 7.51612V6.88809L26.593 7.34431L22.9975 11.1449ZM13.1231 9.60423L12.9487 9.59892C8.56678 9.27449 4.47724 12.7601 4.0187 17.2222L4.01869 17.2222C3.75475 19.7932 4.44937 22.1095 5.88652 23.832C7.32399 25.5548 9.49089 26.6674 12.1409 26.8553C16.7782 27.1846 20.6425 23.9324 21.1301 19.1235L21.1301 19.1232C21.6689 13.7595 17.4792 9.73708 13.1231 9.60423Z"
								fill="#858585"
								stroke="#E4E4E4"
								stroke-width="0.5"
							/>
						</svg>
						<span>Padrillo</span>
					</div>
				</b-nav-item>
				<b-nav-item
					link-classes="py-2 pm-by-nav-item p-25 p-lg-2"
					:to="{ name: 'posturas-sr-por-madrillas' }"
					title=""
				>
					<div
						class="btn-specimen-posturas"
						:class="[$route.meta.category == 2 ? 'btn-specimen-posturas-active' : '']"
					>
						<svg width="23" height="35" viewBox="0 0 23 35" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9.33547 27.1341L9.58919 27.1379V26.8841V23.3447V23.1483L9.39836 23.1019C7.53219 22.6473 5.77803 21.8939 4.32863 20.5767L4.32841 20.5765C0.793944 17.3722 -0.533828 13.3686 0.701918 8.73301L0.701937 8.73294C1.9227 4.14809 4.94449 1.26673 9.55571 0.435831L9.5558 0.435815C15.724 -0.677912 21.4246 3.32246 22.5536 9.61156L22.5536 9.61169C23.6686 15.8045 19.9333 21.5637 13.9457 22.9785L13.9456 22.9786C13.6298 23.0533 13.3666 23.1591 13.1984 23.3716C13.0282 23.5867 12.9958 23.8595 13.0047 24.1587L13.0047 24.16C13.0241 24.7194 13.0181 25.276 13.0116 25.8804C13.0082 26.2021 13.0046 26.5373 13.0046 26.8938V27.1438H13.2546C13.6289 27.1438 13.9957 27.142 14.3575 27.1403C15.0663 27.1369 15.7564 27.1336 16.4476 27.1437L16.45 27.1437C16.7604 27.1453 17.064 27.2409 17.3226 27.4193C17.5814 27.5978 17.7839 27.8514 17.9038 28.149L17.9035 28.1492L17.9087 28.1604C18.2119 28.817 18.1324 29.4666 17.6588 29.9156C17.2888 30.2505 16.8289 30.4613 16.3407 30.5208C15.669 30.5914 14.9981 30.578 14.2602 30.5632C13.9361 30.5567 13.5991 30.55 13.2433 30.55H12.9933V30.8C12.9933 31.0497 12.9949 31.287 12.9964 31.5162C12.9993 31.9506 13.0019 32.3559 12.9934 32.7623C12.9757 33.4068 12.7933 33.9023 12.5065 34.2333C12.2234 34.5599 11.8212 34.7473 11.3132 34.75C10.7823 34.7499 10.371 34.56 10.0866 34.2258C9.79799 33.8867 9.61893 33.3736 9.61165 32.6941V32.6921V32.6887V32.6853V32.6819V32.6786V32.6752V32.6718V32.6684V32.6651V32.6617V32.6583V32.6549V32.6516V32.6482V32.6448V32.6414V32.6381V32.6347V32.6313V32.6279V32.6245V32.6212V32.6178V32.6144V32.611V32.6077V32.6043V32.6009V32.5975V32.5941V32.5908V32.5874V32.584V32.5806V32.5772V32.5739V32.5705V32.5671V32.5637V32.5603V32.5569V32.5536V32.5502V32.5468V32.5434V32.54V32.5366V32.5333V32.5299V32.5265V32.5231V32.5197V32.5163V32.5129V32.5095V32.5062V32.5028V32.4994V32.496V32.4926V32.4892V32.4858V32.4824V32.479V32.4756V32.4722V32.4688V32.4655V32.4621V32.4587V32.4553V32.4519V32.4485V32.4451V32.4417V32.4383V32.4349V32.4315V32.4281V32.4247V32.4213V32.4179V32.4144V32.411V32.4076V32.4042V32.4008V32.3974V32.394V32.3906V32.3872V32.3838V32.3804V32.3769V32.3735V32.3701V32.3667V32.3633V32.3599V32.3564V32.353V32.3496V32.3462V32.3428V32.3393V32.3359V32.3325V32.3291V32.3256V32.3222V32.3188V32.3154V32.3119V32.3085V32.3051V32.3016V32.2982V32.2948V32.2913V32.2879V32.2844V32.281V32.2776V32.2741V32.2707V32.2672V32.2638V32.2603V32.2569V32.2535V32.25V32.2466V32.2431V32.2397V32.2362V32.2327V32.2293V32.2258V32.2224V32.2189V32.2155V32.212V32.2085V32.2051V32.2016V32.1981V32.1947V32.1912V32.1877V32.1843V32.1808V32.1773V32.1738V32.1704V32.1669V32.1634V32.1599V32.1564V32.153V32.1495V32.146V32.1425V32.139V32.1355V32.132V32.1285V32.125V32.1215V32.118V32.1145V32.111V32.1075V32.104V32.1005V32.097V32.0935V32.09V32.0865V32.083V32.0795V32.0759V32.0724V32.0689V32.0654V32.0619V32.0583V32.0548V32.0513V32.0478V32.0442V32.0407V32.0372V32.0336V32.0301V32.0266V32.023V32.0195V32.0159V32.0124V32.0088V32.0053V32.0017V31.9982V31.9946V31.9911V31.9875V31.984V31.9804V31.9768V31.9733V31.9697V31.9662V31.9626V31.959V31.9554V31.9519V31.9483V31.9447V31.9411V31.9375V31.934V31.9304V31.9268V31.9232V31.9196V31.916V31.9124V31.9088V31.9052V31.9016V31.898V31.8944V31.8908V31.8872V31.8836V31.88V31.8763V31.8727V31.8691V31.8655V31.8619V31.8582V31.8546V31.851V31.8473V31.8437V31.8401V31.8364V31.8328V31.8291V31.8255V31.8219V31.8182V31.8146V31.8109V31.8072V31.8036V31.7999V31.7963V31.7926V31.7889V31.7853V31.7816V31.7779V31.7742V31.7706V31.7669V31.7632V31.7595V31.7558V31.7521V31.7484V31.7447V31.741V31.7374V31.7336V31.7299V31.7262V31.7225V31.7188V31.7151V31.7114V31.7077V31.7039V31.7002V31.6965V31.6928V31.689V31.6853V31.6816V31.6778V31.6741V31.6704V31.6666V31.6629V31.6591V31.6554V31.6516V31.6478V31.6441V31.6403V31.6365V31.6328V31.629V31.6252V31.6215V31.6177V31.6139V31.6101V31.6063V31.6025V31.5987V31.5949V31.5912V31.5874V31.5835V31.5797V31.5759V31.5721V31.5683V31.5645V31.5607V31.5569V31.553V31.5492V31.5454V31.5415V31.5377V31.5339V31.53V31.5262V31.5223V31.5185V31.5146V31.5108V31.5069V31.503V31.4992V31.4953V31.4914V31.4876V31.4837V31.4798V31.4759V31.472V31.4682V31.4643V31.4604V31.4565V31.4526V31.4487V31.4448V31.4409V31.4369V31.433V31.4291V31.4252V31.4213V31.4173V31.4134V31.4095V31.4055V31.4016V31.3977V31.3937V31.3898V31.3858V31.3818V31.3779V31.3739V31.37V31.366V31.362V31.358V31.3541V31.3501V31.3461V31.3421V31.3381V31.3341V31.3301V31.3261V31.3221V31.3181V31.3141V31.3101V31.3061V31.3021V31.298V31.294V31.29V31.2859V31.2819V31.2779V31.2738V31.2698V31.2657V31.2617V31.2576V31.2536V31.2495V31.2454V31.2414V31.2373V31.2332V31.2291V31.225V31.2209V31.2169V31.2128V31.2087V31.2046V31.2004V31.1963V31.1922V31.1881V31.184V31.1799V31.1757V31.1716V31.1675V31.1633V31.1592V31.155V31.1509V31.1467V31.1426V31.1384V31.1343V31.1301V31.1259V31.1217V31.1176V31.1134V31.1092V31.105V31.1008V31.0966V31.0924V31.0882V31.084V31.0798V31.0756V31.0714V31.0671V31.0629V31.0587V31.0544V31.0502V31.046V31.0417V31.0375V31.0332V31.0289V31.0247V31.0204V31.0161V31.0119V31.0076V31.0033V30.999V30.9947V30.9904V30.9861V30.9818V30.9775V30.9732V30.9689V30.9646V30.9603V30.9559V30.9516V30.9473V30.9429V30.9386V30.9343V30.9299V30.9255V30.9212V30.9168V30.9125V30.9081V30.9037V30.8993V30.8949V30.8906V30.8862V30.8818V30.8774V30.873V30.8686V30.8641V30.8597V30.8553V30.8509V30.8465V30.842V30.8376V30.8331V30.8287V30.8242V30.8198V30.8153V30.8109V30.8064V30.8019V30.7974V30.793V30.7885V30.784V30.7795V30.775V30.525H9.36165C9.00109 30.525 8.64925 30.5289 8.3022 30.5328C7.62386 30.5405 6.96378 30.5479 6.29255 30.5252C5.80376 30.5035 5.42109 30.3231 5.15916 30.0428C4.89617 29.7614 4.73849 29.3616 4.73427 28.8735L4.73427 28.8732C4.7292 28.3666 4.88886 27.9503 5.1602 27.6548C5.43106 27.3598 5.82889 27.1679 6.33277 27.1376C6.8332 27.1107 7.32799 27.1151 7.83174 27.1196C8.07293 27.1217 8.31616 27.1239 8.56305 27.1226L9.33547 27.1341ZM19.3907 11.7602L19.3907 11.759C19.393 10.164 18.9343 8.60371 18.0719 7.27534C17.2094 5.94691 15.9817 4.90979 14.5433 4.29619C13.1047 3.68255 11.5208 3.52036 9.99205 3.83043C8.46335 4.1405 7.05952 4.90865 5.95777 6.03667C4.85608 7.16462 4.10586 8.60174 3.80104 10.1659C3.49623 11.73 3.6503 13.3518 4.24401 14.8264C4.83774 16.3011 5.84478 17.563 7.13873 18.4517C8.43277 19.3406 9.95533 19.816 11.5138 19.8172L11.5151 19.8172C13.6001 19.8078 15.5961 18.955 17.0701 17.4458C18.5438 15.9369 19.377 13.8938 19.3907 11.7602Z"
								fill="#858585"
								stroke="#E4E4E4"
								stroke-width="0.5"
							/>
						</svg>
						<span>Madrilla</span>
					</div>
				</b-nav-item>
			</ul>
		</div>

		<AddPosturaActiveTask :show="posturasActiveModal" @closing="handleNewPostura" />
		<CheckMadrillasModal v-if="showCheck" @closing="showCheck = false" />

		<router-view @initCounters="initCounters" v-if="showRouter" />
		<b-overlay :show="true" v-else>
			<b-card class="p-2" no-body>
				<b-skeleton-table :rows="8" :columns="4" :table-props="{ bordered: true, striped: true }" />
			</b-card>
		</b-overlay>
	</div>
</template>

<script>
import ComponentTreePosturas from "./TreePosturas/ComponentTreePosturas.vue"
import posturasService from "@/services/posturas.service"
import SpecimenPostureReportByCategory from "./SpecimenPostureReportByCategory.vue"
import { mapMutations, mapState, mapGetters, mapActions } from "vuex"
import fertilidadService from "./insemination/fertilidad.service"
import AddPosturaActiveTask from "./modals/AddPosturaActiveTask.vue"
import CheckMadrillasModal from "@/views/amg/encaste/posturas/modals/CheckMadrillasModal.vue"
import { bus } from "@/main"
import PostureService from "@/services/posturas.service.js"

export default {
	name: "PosturasMain",
	components: {
		ComponentTreePosturas,
		SpecimenPostureReportByCategory,
		AddPosturaActiveTask,
		CheckMadrillasModal,
	},
	async created() {
		await this.A_GET_CHECK_MADRILLAS_COUNTER()
	},
	async mounted() {
		this.season = this.seasons[0].id
		this.setYearMain(this.season)

		await this.initCounters()
		this.GET_COUNTER_PENDINGS()

		const { data } = await fertilidadService.getCounterPending()
		if (data[0]) {
			this.counter = data[0].count
		}
		bus.$on("refreshCounters", async () => {
			await this.initCounters()
		})
	},
	watch: {
		async season(newValue, oldValue) {
			if (oldValue != newValue && oldValue != null) {
				await this.initCounters()
				this.$root.$emit("reloader-posturas-list")
			}
		},
	},
	data() {
		return {
			tabProcessingActive: 0,
			tabArray: [],
			tabIndex: 1,
			activeTabs: false,
			yearMain: new Date().getFullYear(),
			season: null,
			counter: 0,
			posturasActiveModal: false,
			showRouter: true,
			showCheck: false,
			checkCounter: 0,
		}
	},
	computed: {
		...mapGetters({
			G_COUNTER_CHECK_MADRILLAS: "commons/G_GET_CHECK_MADRILLAS_COUNTER",
		}),
		...mapState("encastePosturas", ["start_date", "end_date"]),
		...mapState("encasteInsemination", ["pending"]),
		status() {
			return this.$route.meta.status
		},
	},
	methods: {
		...mapMutations("encastePosturas", ["SET_YEAR_MAIN", "SET_SEASON_MAIN"]),
		...mapMutations("encasteInsemination", ["GET_COUNTER_PENDINGS"]),
		...mapActions({
			A_GET_CHECK_MADRILLAS_COUNTER: "commons/A_GET_CHECK_MADRILLAS_COUNTER",
		}),
		async initCounters() {
			this.activeTabs = false
			this.tabArray = (
				await posturasService.getCountersPosturas({
					start_date: this.start_date,
					end_date: this.end_date,
				})
			).map((it) => {
				return {
					...it,
					path: `posturas-sr-${it.name.toLowerCase()}`,
				}
			})
			this.activeTabs = true
		},
		setYearMain(tr) {
			const { start, end } = this.seasons.find((season) => season.id == tr)
			this.SET_SEASON_MAIN({ start_date: start, end_date: end })
		},
		handleNewPostura() {
			this.posturasActiveModal = !this.posturasActiveModal
			this.initCounters()
			this.refreshRouter()
		},
		refreshRouter() {
			this.showRouter = false
			setTimeout(() => {
				this.showRouter = true
			}, 100)
		},
		async getCheckCounter() {
			const { data } = await PostureService.getCounterMadrillasWithoutEggs()
		},
	},
	destroyed() {
		bus.$off("refreshCounters")
	},
}
</script>

<style scoped lang="scss" scoped>
.borderes {
	border-color: black !important;
	border-radius: 20px !important;
}
.notification-icon-link {
	background: #f00;
	padding: 4px 8px 4px 8px;
	border-radius: 50%;
	color: #fff;
	vertical-align: top;
}
.disabled-switch {
	pointer-events: none;
	opacity: 0.4;
}
.badge-width {
	width: 100%;
	max-width: 60px;
	box-sizing: border-box;
}

.x-tab-width {
	width: 100%;
	@media screen and (min-width: 600px) {
		width: auto;
	}
}

@media screen and (max-width: 500px) {
	.pm-by-nav-item,
	.pm-filter-nav-item {
		margin-top: 1rem;
	}
	.pm-by-nav-item {
		.pm-by-item-label {
			width: 100%;
		}
		.nav-item:not(.pm-by-item-label) {
			width: 50%;
			.nav-link {
				padding-top: 0.5rem !important;
			}
		}
	}
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
.margin-right {
	margin-right: auto;
}
.container-select-year {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	// @media screen and (min-width: 600px) {
	// 	grid-template-columns: repeat(2, 1fr);
	// }

	// @media screen and (min-width: 900px) {
	// 	grid-template-columns: repeat(4, 1fr);
	// }

	// @media screen and (min-width: 1400px) {
	// 	grid-template-columns: repeat(10, 1fr);
	// }
}
.btn-specimen-posturas {
	background: var(--darkest);
	border: 1px solid transparent;
	border-radius: 10px;
	padding: 0.8rem 1.6rem;
	transition: all 400ms ease-in-out;
	box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	display: flex;
	align-items: center;
	svg {
		height: 20px;
		width: 20px;
	}
	span {
		margin-bottom: 0;
		font-weight: bold;
		margin-left: 0rem;
		color: gray;
	}
	&:hover {
		border-color: var(--primary);
	}
}
.btn-specimen-posturas-active {
	background: var(--primary);
	box-shadow: 0 10px 15px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
	svg {
		path {
			fill: #fff;
		}
	}
	span {
		color: #fff;
	}
}
.container-btns-tabs-postura-in-progress {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-bottom: 20px;

	.btn-tab-posturas-in-progress {
		padding: 0.5rem 0.5rem;
		cursor: pointer;
	}

	.btn-tab-posturas-in-progress-active {
		color: var(--primary);
	}
}
.text-insemination {
	border-bottom: 3px solid var(--primary);
	// padding-bottom: .5rem;
	padding: 0 0.8rem 0.4rem 0.8rem;
}
</style>
